import React, { useEffect } from 'react';
import Animated, { useSharedValue, useAnimatedStyle, withRepeat, withTiming, Easing } from 'react-native-reanimated';
import { ILLUSTRATION_NAMES } from '../illustration/illustration.helper';
import { Illustration } from '../illustration/Illustration';

export default function Spinner({ width = 58, height = 58 }) {
  const rotationSV = useSharedValue(360);

  useEffect(() => {
    rotationSV.value = withRepeat(
      withTiming(0, {
        duration: 1200,
        easing: Easing.linear,
      }),
      -1,
      false,
    );
  }, []);

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ rotate: `${rotationSV.value}deg` }],
  }));

  return (
    <Animated.View style={animatedStyle}>
      <Illustration width={width} height={height} name={ILLUSTRATION_NAMES.Spinner} />
    </Animated.View>
  );
}
